import {
  SignIn as ClerkSignIn,
  useSignIn,
  useSignUp,
} from "@clerk/clerk-react";
import urls from "../../routes";
import clerkTheme from "../../ui/ClerkTheme/ClerkTheme";
import image from "../../images/login-signup.webp";
import styles from "./SignIn.module.scss";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Loader from "../../ui/Loader/Loader";
import { jwtDecode } from "jwt-decode";

const decodeTicket = (ticket: string | null) => {
  const decodedTicket = ticket ? jwtDecode(ticket) : null;

  if (
    decodedTicket &&
    "oid" in decodedTicket &&
    typeof decodedTicket.oid === "string"
  ) {
    return decodedTicket;
  }

  return null;
};

function SignIn() {
  const { signIn } = useSignIn();
  const { signUp, setActive } = useSignUp();
  const [searchParams] = useSearchParams();
  const [isReady, setIsReady] = useState(false);

  const decodedTicket = decodeTicket(searchParams.get("__clerk_ticket"));

  useEffect(() => {
    document.title = `Sign In | Macaw`;
  }, []);

  useEffect(() => {
    async function handleSignIn() {
      if (!signUp || !signIn) {
        return;
      }

      const userExistsButNeedsToSignIn =
        signUp.verifications.externalAccount.status === "transferable" &&
        signUp.verifications.externalAccount.error?.code ===
          "external_account_exists";

      if (userExistsButNeedsToSignIn) {
        const res = await signIn.create({ transfer: true });

        if (res.status === "complete") {
          await setActive({
            session: res.createdSessionId,
          });
        }
      }

      const userNeedsToBeCreated =
        signIn.firstFactorVerification.status === "transferable";

      if (userNeedsToBeCreated) {
        const res = await signUp.create({
          transfer: true,
        });

        if (res.status === "complete") {
          await setActive({
            session: res.createdSessionId,
          });
        }
      } else if (searchParams.get("strategy") === "google") {
        await signIn.authenticateWithRedirect({
          strategy: "oauth_google",
          redirectUrl: urls.home,
          redirectUrlComplete: urls.home,
          continueSignUp: true,
        });
      } else {
        setIsReady(true);
      }
    }

    void handleSignIn();
  }, [searchParams, setActive, signIn, signUp]);

  return isReady ? (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <ClerkSignIn
          fallbackRedirectUrl={
            decodedTicket?.oid && typeof decodedTicket.oid === "string"
              ? `${urls.home}?sign_in_with_org=${decodedTicket.oid}`
              : urls.home
          }
          appearance={clerkTheme}
          routing="virtual"
          signUpUrl={urls.signUp}
        />
      </div>
      <div className={styles.imageContainer}>
        <img alt="" className={styles.image} src={image} />
      </div>
    </div>
  ) : (
    <div className={styles.loader}>
      <Loader />
    </div>
  );
}

export default SignIn;
